<template>
  <div id="app">
    <auth-layout v-if="isAuth"></auth-layout>
    <div class="admin-container" v-else>
      <Sidebar :navItems="nav" />
      <div id="right-panel" class="right-panel">
        <Header />
        <div class="content pb-0">
          <transition enter-active-class="animated fadeIn">
            <router-view></router-view>
          </transition>
        </div>
      </div>
    </div>
    <notifications group="foo" position="bottom right" />
  </div>
</template>

<script>
import nav from "./nav";
import Header from "./components/Header.vue";
import Sidebar from "./components/Sidebar.vue";
import AuthLayout from "./layouts/AuthLayout.vue";

export default {
  data() {
    return {
      nav: nav.items,
    };
  },
  components: {
    AuthLayout,
    Header,
    Sidebar,
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched;
    },
    isAuth() {
      return this.$route.path.match("access");
    },
  },
};
</script>

<style lang="scss">
@import url("./assets/css/font-awesome.min.css");
@import url("./assets/css/themify-icons.css");
@import url("./assets/css/pe-icon-7-filled.css");
@import url("./assets/css/flag-icon.min.css");
@import url("./assets/css/cs-skin-elastic.css");

@import "./assets/scss/style";

button {
  cursor: pointer;
}

.shadow {
  background: #fff;
  border-radius: 2px;
  display: inline-block;
  height: 300px;
  margin: 1rem;
  position: relative;
}

.shadow-1 {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.shadow-1:hover {
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}

.shadow-2 {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.shadow-3 {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.shadow-3:hover {
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}
.shadow-4 {
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
}

.shadow-5 {
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
}
/**Style Modal */
.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #00000075;
}

body {
  font-size: 13px !important;
}
.btn {
  font-size: 0.8rem !important;
}
.content {
  padding: 0px !important;
}

.form-control {
  font-size: 0.7rem;
  line-height: 0.6;
}

/* Color Theme Swatches in Hex */
.Light-Dashboard-Scheme-3-1-hex {
  color: #89a0ad;
}
.Light-Dashboard-Scheme-3-2-hex {
  color: #499df2;
}
.Light-Dashboard-Scheme-3-3-hex {
  color: #ecaa47;
}
.Light-Dashboard-Scheme-3-3-hex {
  color: #ec4747;
}
.Light-Dashboard-Scheme-3-4-hex {
  color: #24c0a1;
}
.Light-Dashboard-Scheme-3-5-hex {
  color: #70bea7;
}

.btn-outline-secondary {
  color: #89a0ad;
  background-color: transparent;
  background-image: none;
  border-color: #89a0ad;
}

.btn-outline-secondary:hover {
  color: #fff;
  background-color: #89a0ad;
  border-color: #89a0ad;
}
.btn-outline-primary {
  color: #499df2;
  background-color: transparent;
  background-image: none;
  border-color: #499df2;
}

.btn-outline-primary:hover {
  color: #fff;
  background-color: #499df2;
  border-color: #499df2;
}

.btn-outline-success {
  color: #24c0a1;
  background-color: transparent;
  background-image: none;
  border-color: #24c0a1;
}

.btn-outline-success:hover {
  color: #fff;
  background-color: #24c0a1;
  border-color: #24c0a1;
}
.btn-outline-warning {
  color: #ecaa47;
  background-color: transparent;
  background-image: none;
  border-color: #ecaa47;
}

.btn-outline-warning:hover {
  color: #fff;
  background-color: #ecaa47;
  border-color: #ecaa47;
}
.btn-outline-danger {
  color: #ec4747;
  background-color: transparent;
  background-image: none;
  border-color: #ec4747;
}

.btn-outline-danger:hover {
  color: #fff;
  background-color: #ec4747;
  border-color: #ec4747;
}

.notice {
  padding: 15px;
  background-color: #fafafa;
  border-left: 6px solid #7f7f84;
  margin-bottom: 10px;
  -webkit-box-shadow: 0 5px 8px -6px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 5px 8px -6px rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 8px -6px rgba(0, 0, 0, 0.2);
}
.notice-sm {
  padding: 10px;
  font-size: 80%;
}
.notice-lg {
  padding: 35px;
  font-size: large;
}
.notice-success {
  border-color: #80d651;
}
.notice-success > strong {
  color: #80d651;
}
.notice-info {
  border-color: #45abcd;
}
.notice-info > strong {
  color: #45abcd;
}
.notice-warning {
  border-color: #feaf20;
}
.notice-warning > strong {
  color: #feaf20;
}
.notice-danger {
  border-color: #d73814;
}
.notice-danger > strong {
  color: #d73814;
}
</style>
